import { render, staticRenderFns } from "./overviewData.vue?vue&type=template&id=21c0da25&scoped=true&"
import script from "./overviewData.vue?vue&type=script&lang=js&"
export * from "./overviewData.vue?vue&type=script&lang=js&"
import style0 from "./overviewData.vue?vue&type=style&index=0&id=21c0da25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0da25",
  null
  
)

export default component.exports